const ArcadeShelfWrapperGradient = ({}) => {
  return (
    <div
      style={{
        backgroundImage:
          'linear-gradient(180deg, rgba(9, 9, 9, 1) 0%, rgba(9, 9, 9, 0.00) 50%, #090909 100%)',
        opacity: '1',
        height: '100%'
      }}
      className={`absolute top-0 left-0 right-0`}
    ></div>
  )
}

export default ArcadeShelfWrapperGradient
